<div>
  <div class="user-name-block">

    <h3 class="name text-center">Appointer Information</h3>
    <div class="appointer-view-center" *ngIf="appointerInfo?.addAppointerInfo != 1">
      
      <div *ngIf="appointerInfo == undefined || appointerInfo == null"> Appointer information will be visible once state <span *ngIf="isMGAUser"> and carrier selections are </span> <span *ngIf="!isMGAUser"> selection is </span> made.</div>
      
      <div *ngIf="appointerInfo?.addAppointerInfo == 0" >
      <p class="data-info mt-1">Appointer information is missing for<br>
        <span class="mid-strong">"{{selectedAppointmentWith?.stateName}}"</span>.</p>

      <button *ngIf="!isMGAUser" type="button"
        class="btn border-btn btn-xs px-4 w-100 justify-content-center" (click)="openAddAppointerPopup()">
        Add Missing Appointer Info.
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
          <rect data-name="Rectangle 17995" width="20" height="20" fill="none" />
          <path
            d="M10,15.625a.676.676,0,0,1-.667-.667V10.667H5.042a.667.667,0,0,1,0-1.334H9.333V5.042a.667.667,0,0,1,1.334,0V9.333h4.291a.667.667,0,0,1,0,1.334H10.667v4.291a.676.676,0,0,1-.667.667Z"
            transform="translate(0)" fill="#0068D8" />
        </svg>
      </button>
      </div>
      <div *ngIf="appointerInfo?.addAppointerInfo == 2"> Resident license information not found. Resident license information is required to perform new appointment request. </div>
      
    </div>
  </div>
  <div class="row pt-2" *ngIf="appointerInfo?.addAppointerInfo == 1">
    <div class="col-12">
      <div class="input-block">
        <label class="input-label" for="appointerName">Appointer name</label>
        <input type="text" class="form-control" placeholder="" disabled
          [value]="appointerInfo?.appointerName" name="appointerName" id="appointerName" />
      </div>
      <div class="input-block">
        <label class="input-label" for="appointmentState">State</label>
        <input type="text" class="form-control" placeholder="" disabled
          [value]="appointerInfo?.appStateNameWithStateCode" name="State" id="State" />
      </div>
      <div class="input-block">
        <label class="input-label" for="stateCompanyId">State company code</label>
        <input type="text" class="form-control" placeholder="" disabled
          [value]="appointerInfo?.stateCompanyId" name="stateCompanyId"
          id="stateCompanyId" />
      </div>
      <div class="input-block">
        <label class="input-label" for="licenseNumber">State license number</label>
        <input type="text" class="form-control" placeholder="" disabled
          [value]="appointerInfo?.licenseNumber" name="licenseNumber" id="licenseNumber" />
      </div>
      <div class="input-block">
        <label class="input-label" for="residenceState">Resident state</label>
        <input type="text" class="form-control" placeholder="" disabled
          [value]="appointerInfo?.ResStateNameWithStateCode" name="residenceState" id="residenceState" />
      </div>
      
      <div class="input-block">
        <label class="input-label" for="appointerResidenceStateLicenseId">Resident state license number</label>
        <input type="text" class="form-control" placeholder="" disabled
          [value]="appointerInfo?.appointerResidenceStateLicenseId" name="appointerResidenceStateLicenseId"
          id="appointerResidenceStateLicenseId" />
      </div>
    </div>
  </div>

</div>